import { render } from "./NetworkError.vue?vue&type=template&id=5260f402"
const script = {}
script.render = render

export default script